const translation = {
  currentPlan: 'Trenutni načrt',
  upgradeBtn: {
    plain: 'Nadgradi načrt',
    encourage: 'Nadgradi zdaj',
    encourageShort: 'Nadgradi',
  },
  viewBilling: 'Upravljanje s plačili in naročninami',
  buyPermissionDeniedTip: 'Za naročnino kontaktirajte svojega skrbnika podjetja',
  plansCommon: {
    title: 'Izberite načrt, ki vam ustreza',
    yearlyTip: 'Z letno naročnino pridobite 2 meseca brezplačno!',
    mostPopular: 'Najbolj priljubljeno',
    planRange: {
      monthly: 'Mesečno',
      yearly: 'Letno',
    },
    month: 'mesec',
    year: 'leto',
    save: 'Prihranite ',
    free: 'Brezplačno',
    currentPlan: 'Trenutni načrt',
    contractSales: 'Kontaktirajte prodajo',
    contractOwner: 'Kontaktirajte upravitelja ekipe',
    startForFree: 'Začnite brezplačno',
    getStartedWith: 'Začnite z ',
    contactSales: 'Kontaktirajte prodajo',
    talkToSales: 'Pogovorite se s prodajo',
    modelProviders: 'Ponudniki modelov',
    teamMembers: 'Člani ekipe',
    annotationQuota: 'Kvote za označevanje',
    buildApps: 'Gradite aplikacije',
    vectorSpace: 'Prostor za vektorje',
    vectorSpaceBillingTooltip: 'Vsak 1 MB lahko shrani približno 1,2 milijona znakov vektoriziranih podatkov (ocenjeno z uporabo OpenAI Embeddings, odvisno od modelov).',
    vectorSpaceTooltip: 'Prostor za vektorje je dolgoročni pomnilniški sistem, potreben za to, da LLM-ji razumejo vaše podatke.',
    documentsUploadQuota: 'Kvote za nalaganje dokumentov',
    documentProcessingPriority: 'Prioriteta obdelave dokumentov',
    documentProcessingPriorityTip: 'Za višjo prioriteto obdelave dokumentov nadgradite svoj načrt.',
    documentProcessingPriorityUpgrade: 'Obdelujte več podatkov z večjo natančnostjo in hitrostjo.',
    priority: {
      'standard': 'Standard',
      'priority': 'Prioriteta',
      'top-priority': 'Najvišja prioriteta',
    },
    logsHistory: 'Zgodovina dnevnikov',
    customTools: 'Prilagojena orodja',
    unavailable: 'Ni na voljo',
    days: 'dni',
    unlimited: 'Neomejeno',
    support: 'Podpora',
    supportItems: {
      communityForums: 'Skupnostni forumi',
      emailSupport: 'Podpora preko e-pošte',
      priorityEmail: 'Prioritetna podpora preko e-pošte in klepeta',
      logoChange: 'Sprememba logotipa',
      SSOAuthentication: 'SSO avtentikacija',
      personalizedSupport: 'Osebna podpora',
      dedicatedAPISupport: 'Namenska podpora API-ju',
      customIntegration: 'Prilagojena integracija in podpora',
      ragAPIRequest: 'RAG API zahtevki',
      bulkUpload: 'Masovni prenos dokumentov',
      agentMode: 'Način agenta',
      workflow: 'Potek dela',
      llmLoadingBalancing: 'LLM uravnoteženje obremenitve',
      llmLoadingBalancingTooltip: 'Dodajte več API ključev modelom, kar učinkovito preseže omejitve hitrosti API-ja.',
    },
    comingSoon: 'Kmalu na voljo',
    member: 'Član',
    memberAfter: 'Član',
    messageRequest: {
      title: 'Krediti za sporočila',
      tooltip: 'Kvota za klice sporočil pri različnih načrtih z uporabo modelov OpenAI (razen GPT-4). Sporočila preko omejitve bodo uporabljala vaš OpenAI API ključ.',
      titlePerMonth: '{{count,number}} sporočil/mesec',
    },
    annotatedResponse: {
      title: 'Omejitve kvote za označevanje',
      tooltip: 'Ročno urejanje in označevanje odgovorov omogoča prilagojeno visoko kakovostno odgovarjanje na vprašanja v aplikacijah. (Velja samo za klepetalne aplikacije)',
    },
    ragAPIRequestTooltip: 'Nanaša se na število API klicev, ki vključujejo samo sposobnosti obdelave baze znanja Dify.',
    receiptInfo: 'Le lastnik ekipe in skrbnik ekipe lahko naročita in si ogledate podatke o plačilih',
    self: 'Samostojno gostovanje',
    documents: '{{count,number}} dokumentov znanja',
    documentsTooltip: 'Kvote na število dokumentov, uvoženih iz Vir podatkov znanja.',
    teamWorkspace: '{{count,number}} Ekipa delovni prostor',
    apiRateLimit: 'Omejitev hitrosti API-ja',
    unlimitedApiRate: 'Brez omejitve hitrostnega limita API-ja',
    comparePlanAndFeatures: 'Primerjajte načrte in funkcije',
    apiRateLimitTooltip: 'API omejitev hitrosti velja za vse poizvedbe, opravljene prek Dify API, vključno z generiranjem besedila, klepetnimi pogovori, izvajanjem delovnih tokov in obdelavo dokumentov.',
    freeTrialTipSuffix: 'Brez zahteve po kreditni kartici',
    annualBilling: 'Letno račунovodstvo',
    teamMember_one: '{{count,number}} član ekipe',
    teamMember_other: '{{count,number}} Članov ekipe',
    documentsRequestQuota: '{{count,number}}/min Omejitev stopnje zahtev po znanju',
    apiRateLimitUnit: '{{count,number}}/dan',
    priceTip: 'na delovnem prostoru/',
    freeTrialTipPrefix: 'Prijavite se in prejmite',
    cloud: 'Oblačna storitev',
    freeTrialTip: 'brezplačno preizkušnjo 200 klicev OpenAI.',
    getStarted: 'Začnite',
    documentsRequestQuotaTooltip: 'Določa skupno število dejanj, ki jih lahko delovno mesto opravi na minuto znotraj znanja baze, vključno s kreiranjem, brisanjem, posodobitvami, nalaganjem dokumentov, spremembami, arhiviranjem in poizvedbami po znanju bazi. Ta meritev se uporablja za ocenjevanje uspešnosti poizvedb v bazi znanja. Na primer, če uporabnik Sandbox izvede 10 zaporednih testov udarca v eni minuti, bo njegovo delovno mesto začasno omejeno pri izvajanju naslednjih dejanj v naslednji minuti: kreiranje podatkovnih nizov, brisanje, posodobitve in nalaganje ali spremembe dokumentov.',
  },
  plans: {
    sandbox: {
      name: 'Peskovnik',
      description: '200 brezplačnih poskusov GPT',
      includesTitle: 'Vključuje:',
      for: 'Brezplačno preizkušanje osnovnih zmogljivosti',
    },
    professional: {
      name: 'Profesionalni',
      description: 'Za posameznike in male ekipe, da odklenete več zmogljivosti po ugodni ceni.',
      includesTitle: 'Vse v brezplačnem načrtu, plus:',
      for: 'Za neodvisne razvijalce/male ekipe',
    },
    team: {
      name: 'Ekipa',
      description: 'Sodelujte brez omejitev in uživajte v vrhunski zmogljivosti.',
      includesTitle: 'Vse v profesionalnem načrtu, plus:',
      for: 'Za srednje velike ekipe',
    },
    enterprise: {
      name: 'Podjetje',
      description: 'Pridobite vse zmogljivosti in podporo za velike sisteme kritične za misijo.',
      includesTitle: 'Vse v načrtu Ekipa, plus:',
      features: {
        5: 'Pogajali smo se o SLAs s partnerji Dify',
        4: 'SSO',
        0: 'Rešitve za razširljivo uvedbo na ravni podjetij',
        1: 'Avtorizacija za komercialno licenco',
        2: 'Ekskluzivne funkcije za podjetja',
        7: 'Posodobitve in vzdrževanje s strani Dify uradno',
        3: 'Več delovnih prostorov in upravljanje podjetij',
        6: 'Napredna varnost in nadzor',
        8: 'Profesionalna tehnična podpora',
      },
      priceTip: 'Letno zaračunavanje samo',
      price: 'Po meri',
      btnText: 'Kontaktirajte prodajo',
      for: 'Za velike ekipe',
    },
    community: {
      features: {
        2: 'Upošteva Dify odprtokodno licenco',
        0: 'Vse ključne funkcije so bile objavljene v javnem repozitoriju',
        1: 'Enotno delovno okolje',
      },
      includesTitle: 'Brezplačne funkcije:',
      price: 'Brezplačno',
      name: 'Skupnost',
      description: 'Za posamezne uporabnike, majhne skupine ali nekomercialne projekte',
      for: 'Za posamezne uporabnike, majhne skupine ali nekomercialne projekte',
      btnText: 'Začnite s skupnostjo',
    },
    premium: {
      features: {
        2: 'Prilagoditev logotipa in blagovne znamke spletne aplikacije',
        1: 'Enotno delovno okolje',
        0: 'Samoobvladovana zanesljivost različnih ponudnikov oblačnih storitev',
        3: 'Prednostna e-pošta in podpora za klepet',
      },
      name: 'Premium',
      priceTip: 'Na podlagi oblaka Marketplace',
      price: 'Škalable',
      includesTitle: 'Vse iz skupnosti, poleg tega:',
      comingSoon: 'Podpora za Microsoft Azure in Google Cloud kmalu prihaja',
      for: 'Za srednje velika podjetja in ekipe',
      btnText: 'Pridobi Premium v',
      description: 'Za srednje velika podjetja in ekipe',
    },
  },
  vectorSpace: {
    fullTip: 'Prostor za vektorje je poln.',
    fullSolution: 'Nadgradite svoj načrt za več prostora.',
  },
  apps: {
    fullTipLine1: 'Nadgradite svoj načrt, da',
    fullTipLine2: 'gradite več aplikacij.',
    fullTip1des: 'Dosegli ste omejitev za izdelavo aplikacij v tem načrtu.',
    fullTip1: 'Nadgradite za ustvarjanje več aplikacij',
    fullTip2: 'Dosežena meja načrta',
    contactUs: 'Kontaktirajte nas',
    fullTip2des: 'Priporočljivo je, da očistite neaktivne aplikacije, da sprostite prostor, ali nas kontaktirate.',
  },
  annotatedResponse: {
    fullTipLine1: 'Nadgradite svoj načrt, da',
    fullTipLine2: 'označite več pogovorov.',
    quotaTitle: 'Kvote za odgovor z označevanjem',
  },
  usagePage: {
    documentsUploadQuota: 'Kvota za nalaganje dokumentov',
    vectorSpaceTooltip: 'Dokumenti z načinom indeksiranja visoke kakovosti bodo porabili vire skladišča podatkov o znanju. Ko skladišče podatkov o znanju doseže mejo, novih dokumentov ne bo mogoče naložiti.',
    vectorSpace: 'Shranjevanje podatkov znanja',
    annotationQuota: 'Quota za anotacijo',
    teamMembers: 'Člani ekipe',
    buildApps: 'Gradite aplikacije',
  },
  teamMembers: 'Člani ekipe',
}

export default translation
